import { render, staticRenderFns } from "./IcebergMinuteView.vue?vue&type=template&id=ba538f2c&scoped=true"
import script from "./IcebergMinuteView.vue?vue&type=script&lang=js"
export * from "./IcebergMinuteView.vue?vue&type=script&lang=js"
import style0 from "./IcebergMinuteView.vue?vue&type=style&index=0&id=ba538f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba538f2c",
  null
  
)

export default component.exports